<template>
<div>
  <div class="list-analytics analysis-chart" v-show="mainChartVisible">
    <div class="t-chart c-pointer">
      <div class="title corner" @click="onClickAddButton">
        메모리 사용률
        <div :class="addButtonIconName"></div>
      </div>
      <w-plot-line-chart ref="memUserateChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart" />
    </div>
  </div>

  <div v-show="subChartVisible" class="sub-chart-wrapper">
    <div class="list-analytics analysis-chart">
      <div class="t-chart">
        <div class="title">전체용량</div>
        <w-plot-line-chart ref="totalcapacityChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['TOTALCAPACITY']" @clickChart="onClickChart" />
      </div>
    </div>
    <div class="list-analytics analysis-chart">
      <div class="t-chart">
        <div class="title">사용량</div>
        <w-plot-line-chart ref="usecapacityChart" :active="active" :visible="subChartVisible" :rscInfoList="subRscInfo['USEDCAPACITY']" @clickChart="onClickChart" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

export default {
  name: 'WHostMemAnalysisChart',
  components: {
    WPlotLineChart,
  },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [
        {
          rsctypeId: 'VHO_MEM',
          rscId: 'USERATE',
          rscKey: '_',
        },
      ],
      subRscInfo: {
        TOTALCAPACITY: [
          {
            rsctypeId: 'VHO_MEM',
            rscId: 'TOTAL_CAPACITY',
            rscKey: '_',
          },
        ],
        USEDCAPACITY: [
          {
            rsctypeId: 'VHO_MEM',
            rscId: 'USED_CAPACITY',
            rscKey: '_',
          },
        ],
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/virtual/components/chart/HostMemAnalysisChart.vue